import * as React from "react";
const SvgBin = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M17.8714 18.7052L19 7H5L6.12859 18.7052C6.23538 20.0019 7.319 21 8.62016 21H15.3798C16.681 21 17.7646 20.0019 17.8714 18.7052ZM7.20211 9L8.1207 18.5271L8.12185 18.541C8.1432 18.8004 8.35993 19 8.62016 19H15.3798C15.6401 19 15.8568 18.8004 15.8782 18.541L15.8793 18.5271L16.7979 9H7.20211Z",
	fill: "black"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.2921 3.50017C14.9063 2.61713 14.0252 2 13 2H11C9.97477 2 9.09368 2.61713 8.70795 3.50017L5 3.5C4.44772 3.5 4 3.94772 4 4.5V5.25C4 5.38807 4.11193 5.5 4.25 5.5H19.75C19.8881 5.5 20 5.38807 20 5.25V4.5C20 3.94772 19.5523 3.5 19 3.5L15.2921 3.50017Z",
	fill: "black"
}));
export default SvgBin;
